/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** 任务回复（Task Reply） */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** 任务回复（Task Reply） 查询卡涩问题详情 */
export async function getClarificationDetailGet(
  payload: {
    clarificationId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultClarificationDetailResp>({
    url: `/es/api/biz/task-reply/clarification/detail`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 任务回复（Task Reply） 查询卡涩问题列表 */
export async function listClarificationsGet(
  payload: {
    inquiryTaskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultListClarificationResp>({
    url: `/es/api/biz/task-reply/clarification/list`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 任务回复（Task Reply） 用户回复卡涩问题 */
export async function replyClarificationPost(payload: model.IApiClarificationReplyReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/task-reply/clarification/reply`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 任务回复（Task Reply） 查询询盘联系人列表 */
export async function listInquiryContactsGet(
  payload: {
    inquiryTaskId: string;
    pageNum?: number;
    pageSize?: number;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiPageableResultInquiryContactResp>({
    url: `/es/api/biz/task-reply/inquiry-contact/list`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 任务回复（Task Reply） 查询用户自动回复开关配置 */
export async function getAutoReplySettingGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultint>({
    url: `/es/api/biz/task-reply/setting/auto-reply`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** 任务回复（Task Reply） 批量查询联系人自动回复开关 */
export async function batchGetContactAutoReplyPost(
  payload: model.IApiBatchContactAutoReplyReq,
  options?: RequestOptions
) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultListContactAutoReplyResp>({
    url: `/es/api/biz/task-reply/setting/auto-reply/batch`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 任务回复（Task Reply） 切换自动回复开关 */
export async function replyTogglePut(payload: model.IApiAutoReplyToggleReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/task-reply/toggle`,
    method: 'put',
    data,
    ...options,
  });

  return result.data;
}
